<template>
  <div>
    <BaseHeader
      :title="$t('navigation.labels.landingpages')"
      :style-variant="2"
    >
      <template
        v-if="!isPlatformBottimmo"
        v-slot:design
      >
        <HeaderDesign />
      </template>

      <template v-slot:desc>
        <p>
          {{
            isFeatureActive(featureNames.CONTRACT)
              ? $t('landingpages.download-area.has-contract-title')
              : $t('landingpages.download-area.no-contract-title')
          }}
        </p>
      </template>
      <template v-slot:content>
        <div
          class="pb-2 d-flex"
          style="flex-wrap: wrap"
        >
          <v-btn
            v-if="landingpageOverviewUrl"
            class="ml-0"
            variant="text"
            color="primary"
          >
            <a
              class="info-link"
              target="_blank"
              rel="noopener noreferrer"
              :href="landingpageOverviewUrl"
              @click="$tracking.event('Landingpages', 'Clicked', 'Landingpage Overview')"
              >{{ $t('landingpages.download-area.overview') }}</a
            >
            <v-icon end> mdi-view-grid-outline </v-icon>
          </v-btn>

          <Feature
            v-slot="{ feature }"
            :feature-slug="featureNames.MATERIAL_GUIDE"
          >
            <v-btn
              class="ml-0"
              variant="text"
              color="primary"
            >
              <a
                class="info-link"
                target="_blank"
                rel="noopener noreferrer"
                @click="$tracking.event('Landingpages', 'Clicked', 'Implementation Guide')"
                :href="getGuideUrl(feature)"
                >{{ $t('landingpages.download-area.guide-url') }}</a
              >
              <v-icon end> mdi-link </v-icon>
            </v-btn>
          </Feature>

          <v-btn
            v-if="hasWidgets"
            class="ml-0"
            color="primary"
            variant="text"
            @click="downloadImplementationData"
          >
            {{ $t('landingpages.download-area.download') }}
            <v-icon end> mdi-download </v-icon>
          </v-btn>

          <Download
            v-if="hasMaterialsFeature"
            variant="text"
            :title="$t('landingpages.download-area.all-materials')"
            path="/materials/all"
            filename="Materialien"
          />
        </div>
      </template>
    </BaseHeader>
  </div>
</template>

<script>
import BaseHeader from '@/components/BaseHeader.vue'
import { exportImplementationData } from '@/lib/export'
import { getMaterialGuideUrl } from '@/lib/materialGuideUrl'
import brandingMixin from '@/mixins/branding.js'
import featureMixin from '@/mixins/feature'

import Download from './Download.vue'
import HeaderDesign from './HeaderDesign.vue'
import LANDINGPAGE_OVERVIEW from './LandingpageOverview.gql'

export default {
  components: { Download, BaseHeader, HeaderDesign },
  mixins: [featureMixin, brandingMixin],
  data() {
    return {
      currentLocale: this.$i18n.locale,
    }
  },
  computed: {
    landingpageOverviewUrl() {
      if (!this.hasHomepage) return ''
      if (!this.company?.site) return ''
      return this.company?.site.url
    },

    hasMaterialsFeature() {
      const feature = this.getFeature(this.featureNames.LANDINGPAGE)
      return feature.isActive && (feature.config.hasMaterials || feature.config.hasStaticMaterials)
    },
    hasHomepage() {
      return (
        this.isFeatureActive(this.featureNames.LANDINGPAGE) &&
        this.getFeature(this.featureNames.LANDINGPAGE)?.config.hasHomepage
      )
    },
    hasWidgets() {
      const feature = this.$features.feature(this.featureNames.CMS)
      return !feature.isActive || feature.config.hasWidgets
    },
  },
  methods: {
    async downloadImplementationData() {
      await exportImplementationData(this.$auth.user.companyId)
      this.$tracking.event('Landingpages', 'Clicked', 'Download Implementation Data')
    },
    getGuideUrl(feature) {
      return getMaterialGuideUrl({
        config: feature.config,
        locale: this.currentLocale,
        isSmg: this.isPlatformSmg,
      })
    },
  },
  apollo: {
    company: {
      query: LANDINGPAGE_OVERVIEW,
      variables() {
        return {
          id: this.$auth.user.companyId,
        }
      },
    },
  },
}
</script>

<style scoped>
.info-link {
  text-decoration: none;
}
</style>
